import { Store } from '@ngxs/store';
import { PageActions } from './page.actions';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
export let PageFacade = /*#__PURE__*/(() => {
  class PageFacade {
    constructor(store) {
      this.store = store;
    }
    setTitle(name) {
      return new Promise(res => {
        setTimeout(() => {
          res(this.store.dispatch(new PageActions.SetTitle(name)));
        });
      });
    }
    setMeta(data) {
      return new Promise(res => {
        setTimeout(() => {
          res(this.store.dispatch(new PageActions.SetMeta(data)));
        });
      });
    }
    static {
      this.ɵfac = function PageFacade_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PageFacade)(i0.ɵɵinject(i1.Store));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: PageFacade,
        factory: PageFacade.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return PageFacade;
})();